const TENANT = require('./constants/tenant');

const getTheme = () => {
  const colors = {
    /* eslint-disable  global-require */
    [TENANT.EXECNET]: require('./constants/execnet/globalColors'),
    [TENANT.CONEXAOSAUDE]: require('./constants/conexaosaude/globalColors'),
    default: require('./constants/coop/globalColors'),
    /* eslint-enable */
  };

  if (colors[process.env.REACT_APP_COOP_NAME]) {
    return colors[process.env.REACT_APP_COOP_NAME];
  }

  return colors.default;
};

module.exports = {
  corColaboradorAfastado: '#CC1D33',
  corColaboradorSemContrato: '#FABA00',
  corColaboradorPendenciaESocial: '#820DDB',
  ...getTheme(),
};
